import React, { useEffect, useReducer, useState } from "react";
import DashboardLayout from "../../../../layoutcontainers/DashboardLayout";
import {
  Autocomplete,
  Box,
  Card,
  CardHeader,
  Chip,
  IconButton,
  Stack,
  Tab,
  Tabs,
  TextField,
} from "@mui/material";
import Swal from "sweetalert2";
import MaterialTypography from "../../../../components/MaterialTypography";
import MaterialDataGrid from "../../../../components/MaterialDataGrid";
import PageLoading from "../../../../components/Loading/PageLoading";
import { useNavigate } from "react-router-dom";
import VisibilityIcon from "@mui/icons-material/Visibility";
import _ from "lodash";
import { useLoading } from "../../../../context/LodingContext";
import request from "graphql-request";
import BASEURL from "../../../../pages/Utils/Baseurl";
import { downloadExcelFile } from "../../../function/downloadExcel";
import {
  allProductCategories,
  allBrands,
  allProducts,
  FilterProducts,
  exportInventoryMaster,
  allProductsDropdown,
  realtimeinventeryList,
} from "../ReportData";
import MaterialInput from "../../../../components/MaterialInput";
import MaterialBox from "../../../../components/MaterialBox";
import Grid from "@mui/material/Grid2";
import {
  Tooltip,
  Legend,
  ResponsiveContainer,
  BarChart,
  CartesianGrid,
  XAxis,
  YAxis,
  Bar,
} from "recharts";
import OptionConvert from "../../../components/OptionConvert";
import RefreshIcon from "@mui/icons-material/Refresh";
import {
  realtimeInventoryState,
  RealtimeInventoryStateMange,
} from "../ReportStateMange";
import { todayDateProducts } from "../../todayProduct/todayProductData";
import URL from "../../../../pages/Utils/url";
import ReusableFilter from "../../../components/ReusableFilter";
import FilterListIcon from "@mui/icons-material/FilterList";
import ReportDefaultUi from "../reportDefaultui";
import AppliedFilter from "../AppliedFilter/AppliedFilter";
import ReportGraphPanel from "../ReportGraphPanel";

function RealtimeInventory() {
  const navigate = useNavigate();
  const { setCirleLoading } = useLoading();
  const [inventoryData, dispatch] = useReducer(
    RealtimeInventoryStateMange,
    realtimeInventoryState,
  );
  const [isTabel, setIsTabel] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [datas, setData] = useState([]);
  const [value, setValue] = useState(0); // 0 for Table list view, 1 for Graph view
  const [productCategoryOptions, setProductCategoryOptions] = useState([
    { label: "All", value: "All" },
  ]);
  const [brandOptions, setBrandOptions] = useState([
    { label: "All", value: "All" },
  ]);
  const [productNameOptions, setProductNameOptions] = useState([
    { label: "All", value: "All" },
  ]);

  // Graph pagination follows the same server page as the table.
  const [currentPage, setCurrentPage] = useState(0);
  const [tablePaginationModel, setTablePaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });
  const [totalCount, setTotalCount] = useState(0);
  const [serverTotalPages, setServerTotalPages] = useState(0);
  const [activeReportFilters, setActiveReportFilters] = useState(null);

  useEffect(() => {
    fetchCategories();
    fetchBrand();
    fetchProductName();
    // fetchFilteredStock();
    setIsTabel(false);
  }, []);

  const totalPages = serverTotalPages;
  const currentData = datas;

  // Reset pagination when data changes or tab switches
  const resetPagination = () => {
    setCurrentPage(0);
  };

  const handleGraphPageChange = (page) => {
    if (
      !activeReportFilters ||
      isLoading ||
      page < 0 ||
      page >= serverTotalPages
    ) {
      return;
    }

    fetchFilteredStock(
      activeReportFilters.startDate,
      activeReportFilters.endDate,
      activeReportFilters.categories,
      activeReportFilters.products,
      activeReportFilters.brands,
      page,
      tablePaginationModel.pageSize,
    );
  };

  const handleTablePaginationChange = (model) => {
    if (
      model.page === tablePaginationModel.page &&
      model.pageSize === tablePaginationModel.pageSize
    ) {
      return;
    }

    const nextModel = {
      page: model.pageSize !== tablePaginationModel.pageSize ? 0 : model.page,
      pageSize: model.pageSize,
    };
    setTablePaginationModel(nextModel);

    if (activeReportFilters) {
      fetchFilteredStock(
        activeReportFilters.startDate,
        activeReportFilters.endDate,
        activeReportFilters.categories,
        activeReportFilters.products,
        activeReportFilters.brands,
        nextModel.page,
        nextModel.pageSize,
      );
    }
  };

  // Table columns and rows definition
  const RealtimeInventoryListTable = {
    columns: [
      {
        headerName: "S.No",
        field: "sno",
        name: "S.NO",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
      {
        headerName: "Product Category",
        field: "productCategory",
        name: "productCategory",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
      },
      {
        headerName: "Product Code",
        field: "productCode",
        name: "productCode",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
      },
      {
        headerName: "Product Name",
        field: "productName",
        name: "productName",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
      },
      {
        headerName: "Brand",
        field: "productBrand",
        name: "productBrand",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
      {
        headerName: "Current Stock",
        field: "currentStock",
        name: "currentStock",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
      {
        headerName: "Original Stock",
        field: "originalStock",
        name: "originalStock",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
      {
        headerName: "Created By",
        field: "createdBy",
        name: "createdBy",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },

      {
        headerName: "Action",
        field: "Action",
        name: "Action",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
    ],
    // The `rows` will be the full `datas` array, as MaterialDataGrid handles its own pagination.
    rows: datas?.map((v, i) => ({
      sno: i + 1, // S.No for display, MaterialDataGrid will handle its own row IDs
      id: i + 1, // Unique ID for MaterialDataGrid
      productCategory: v?.productCategory,
      productName: v?.productName,
      productBrand: v?.productBrand,
      currentStock: v?.currentStock,
      originalStock: v?.originalStock,
      productCode: v?.productCode,
      createdBy: v?.user?.employeeName,
      Action: (
        <div>
          <VisibilityIcon
            style={{
              color: "GrayText",
              fontSize: "25px",
              cursor: "pointer",
              margin: "10px 10px",
            }}
            onClick={() =>
              navigate(`/realtime-inventory/view`, {
                state: { type: "view", data: v },
              })
            }
          />
        </div>
      ),
    })),
  };

  // Function to download excel file
  const handleDownload = (
    startDate,
    endDate,
    productCategory,
    brand,
    productName,
  ) => {
    const categories =
      productCategory?.length > 0
        ? productCategory?.map((item) => item.label) || []
        : [];
    const brands =
      brand?.length > 0 ? brand?.map((item) => item.label) || [] : [];
    const products =
      productName?.length > 0
        ? productName?.map((item) => item.label) || []
        : [];

    setCirleLoading(true);
    request(BASEURL, exportInventoryMaster, {
      startDate,
      endDate,
      categories,
      brands,
      products,
      page: 1,
      pageSize: 10,
    })
      .then(async (res) => {
        const status = res?.exportFilteredProduct?.success;

        const pdfurl = `${URL}${res?.exportFilteredProduct?.fileUrl?.slice(1)}`;

        if (status) {
          const status = await downloadExcelFile(
            pdfurl,
            "realtime_inventory.xlsx",
          );
          setCirleLoading(false);
        }
      })
      .catch((err) => {
        const message =
          err?.response?.errors?.[0]?.message ||
          err?.message ||
          "Failed to export file.";
        Swal.fire({
          position: "top",
          icon: "error",
          title: message,
          showConfirmButton: true,
        });
        setCirleLoading(false);
      })
      .finally(() => {
        setCirleLoading(false);
      });
  };

  // Function to fetch inventory data (initial load or reset)
  const fetchInventoryData = () => {
    setIsLoading(true);
    request(BASEURL, realtimeinventeryList)
      .then((res) => {
        const newdata = res?.todayDateProductsDropdown?.data;
        setData(newdata);
        resetPagination(); // Reset graph pagination when data changes
      })
      .catch((err) => {
        const message =
          err?.response?.errors?.[0]?.message ||
          err?.message ||
          "Failed to fetch today's products.";
        Swal.fire({
          position: "top",
          icon: "error",
          title: message,
          showConfirmButton: true,
        });
        setData([]); // Clear data on error
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  // Function to fetch product categories
  const fetchCategories = () => {
    request(BASEURL, allProductCategories)
      .then((res) => {
        const Categories = OptionConvert(
          res?.allProductCategories?.data,
          "categoryName",
          "id",
        );
        setProductCategoryOptions((prevOptions) => [
          { label: "All", value: "All" },
          ...Categories,
        ]);
      })
      .finally(() => {});
  };

  // Function to fetch brands
  const fetchBrand = () => {
    request(BASEURL, allBrands)
      .then((res) => {
        const brand = OptionConvert(res?.allBrands?.data, "brandName", "id");
        setBrandOptions((prevOptions) => [
          { label: "All", value: "All" },
          ...brand,
        ]);
      })
      .finally(() => {});
  };

  // Function to fetch product names
  const fetchProductName = () => {
    request(BASEURL, allProductsDropdown)
      .then((res) => {
        const productName = res?.allProductsDropdown?.data.map((item) => ({
          id: item?.id,
          value: item?.productCode,
          label: item?.productName,
        }));
        setProductNameOptions((prevOptions) => [
          { label: "All", value: "All" },
          ...productName,
        ]);
      })
      .finally(() => {});
  };

  // Function to fetch filtered products
  const fetchFilteredProducts = (
    startDate,
    endDate,
    categories,
    brands,
    products,
  ) => {
    setIsLoading(true);
    request(BASEURL, FilterProducts, {
      startDate,
      endDate,
      categories,
      brands,
      products,
    })
      .then((res) => {
        const newdata = res?.filterProducts?.data;
        setData(newdata);
        resetPagination(); // Reset graph pagination when filtered data changes
      })
      .catch((err) => {
        const message =
          err?.response?.errors?.[0]?.message ||
          err?.message ||
          "Something went wrong while filtering products.";
        Swal.fire({
          position: "top",
          icon: "error",
          title: message,
          showConfirmButton: true,
        });
        setData([]); // Clear data on error
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  // Function to reset all filters
  const resetFilters = () => {
    dispatch({ name: "reset" });
    setActiveReportFilters(null);
    setData([]);
    setTotalCount(0);
    setServerTotalPages(0);
    setIsTabel(false);
    setIsLoading(false);
    setCurrentPage(0);
    setTablePaginationModel({ page: 0, pageSize: 10 });
  };

  // Handler for tab change
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  //filter submit
  const submitFilter = (data) => {
    const productCategories =
      inventoryData?.productCategory.length > 0
        ? inventoryData?.productCategory?.map((item) => item.label)
        : [];
    const brands =
      inventoryData?.brand.length > 0
        ? inventoryData?.brand?.map((item) => item.label)
        : [];
    const productName =
      inventoryData?.productName.length > 0
        ? inventoryData?.productName?.map((item) => item.label)
        : [];

    console.log(
      inventoryData.fromDate,
      inventoryData.toDate,
      productCategories,
      productName,
      brands,
    );

    const filters = {
      startDate: inventoryData.fromDate,
      endDate: inventoryData.toDate,
      categories: productCategories,
      products: productName,
      brands,
    };
    setActiveReportFilters(filters);
    setTablePaginationModel({ page: 0, pageSize: 10 });
    setCurrentPage(0);
    fetchFilteredStock(
      filters.startDate,
      filters.endDate,
      filters.categories,
      filters.products,
      filters.brands,
      0,
      10,
    );
  };

  //filter api call
  const fetchFilteredStock = (
    startDate,
    endDate,
    productCategories,
    productName,
    brands,
    page = 0,
    pageSize = 10,
  ) => {
    setIsTabel(true);
    setIsLoading(true);

    const payload = {
      startDate: startDate,
      endDate: endDate,
      categories: productCategories,
      products: productName,
      brands: brands,
      page: page + 1,
      pageSize,
    };

    request(BASEURL, FilterProducts, payload)
      .then((res) => {
        const result = res?.filterProducts;
        const newdata = result?.data || [];
        setData(newdata);
        setTotalCount(result?.totalCount || 0);
        setServerTotalPages(result?.totalPages || 0);
        setCurrentPage(Math.max((result?.currentPage || page + 1) - 1, 0));
        setTablePaginationModel({
          page: Math.max((result?.currentPage || page + 1) - 1, 0),
          pageSize,
        });
      })
      .catch((err) => {
        const message =
          err?.response?.errors?.[0]?.message ||
          err?.message ||
          "Something went wrong";
        Swal.fire({
          position: "top",
          icon: "error",
          title: message,
          showConfirmButton: true,
        });
      })
      .finally(() => {
        setIsLoading(false);
        setIsTabel(true);
      });
  };

  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  Realtime Inventory Management List
                </MaterialTypography>
              </Stack>
              <Box sx={{ mx: "5%" }}>
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  {datas.length > 0 && (
                    <Box sx={{ width: "100%", bgcolor: "background.paper" }}>
                      <Tabs
                        value={value}
                        onChange={handleChange}
                        TabIndicatorProps={{
                          style: {
                            backgroundColor: "#2a9941",
                            color: "white",
                          },
                        }}
                        sx={{ px: 2 }}
                        centered
                      >
                        <Tab sx={{ px: 2 }} label="Table list view" />
                        <Tab sx={{ px: 2 }} label="Graph view" />
                      </Tabs>
                    </Box>
                  )}
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-end",
                      bgcolor: "background.paper",
                    }}
                  >
                    <IconButton
                      onClick={() => setDialogOpen(true)}
                      aria-label="Filters"
                      color="primary"
                    >
                      <FilterListIcon fontSize="medium" />
                    </IconButton>
                    <IconButton
                      onClick={resetFilters}
                      aria-label="Reset Filters"
                      color="primary"
                    >
                      <RefreshIcon fontSize="medium" />
                    </IconButton>
                  </Box>
                </Stack>
              </Box>

              {/* Export File button, visible only when dates are selected */}
              {inventoryData?.fromDate && inventoryData?.toDate && (
                <button
                  className="container-btn-file"
                  onClick={() => {
                    handleDownload(
                      inventoryData?.fromDate,
                      inventoryData?.toDate,
                      inventoryData?.productCategory,
                      inventoryData?.brand,
                      inventoryData?.productName,
                    );
                  }}
                  style={{
                    height: "38px",
                    marginLeft: "0",
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    fontSize: "14px",
                  }}
                >
                  <svg
                    fill="#fff"
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 50 50"
                  >
                    <path d="M28.8125 .03125L.8125 5.34375C.339844 5.433594 0 5.863281 0 6.34375L0 43.65625C0 44.136719 .339844 44.566406 .8125 44.65625L28.8125 49.96875C28.875 49.980469 28.9375 50 29 50C29.230469 50 29.445313 49.929688 29.625 49.78125C29.855469 49.589844 30 49.296875 30 49L30 1C30 .703125 29.855469 .410156 29.625 .21875C29.394531 .0273438 29.105469 -.0234375 28.8125 .03125ZM32 6L32 13L34 13L34 15L32 15L32 20L34 20L34 22L32 22L32 27L34 27L34 29L32 29L32 35L34 35L34 37L32 37L32 44L47 44C48.101563 44 49 43.101563 49 42L49 8C49 6.898438 48.101563 6 47 6ZM36 13L44 13L44 15L36 15ZM6.6875 15.6875L11.8125 15.6875L14.5 21.28125C14.710938 21.722656 14.898438 22.265625 15.0625 22.875L15.09375 22.875C15.199219 22.511719 15.402344 21.941406 15.6875 21.21875L18.65625 15.6875L23.34375 15.6875L17.75 24.9375L23.5 34.375L18.53125 34.375L15.28125 28.28125C15.160156 28.054688 15.035156 27.636719 14.90625 27.03125L14.875 27.03125C14.8125 27.316406 14.664063 27.761719 14.4375 28.34375L11.1875 34.375L6.1875 34.375L12.15625 25.03125ZM36 20L44 20L44 22L36 22ZM36 27L44 27L44 29L36 29ZM36 35L44 35L44 37L36 37Z" />
                  </svg>
                  Export File
                </button>
              )}
            </Stack>
          }
        />

        {/* Tabs for switching between Table and Graph views */}
        <AppliedFilter
          onSave={(data) =>
            submitFilter({
              ...data,
              inventoryData,
            })
          }
          data={inventoryData}
          dispatch={dispatch}
          chipDisplay={["productCategory", "productName", "brandName"]}
        />
        {/* Filter fields */}
        <ReusableFilter
          data={inventoryData}
          dispatch={dispatch}
          open={dialogOpen}
          onClose={() => setDialogOpen(false)}
          onSave={(data) =>
            submitFilter({
              ...data,
              inventoryData,
            })
          }
          title="Real Time Inventory Filter"
        >
          <Grid size={{ xs: 12, sm: 6 }}>
            <MaterialBox lineHeight={0} display="inline-block">
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Product Category
              </MaterialTypography>
            </MaterialBox>
            <Autocomplete
              multiple
              id="product-category-autocomplete"
              options={productCategoryOptions || []}
              getOptionLabel={(option) => option.label || ""}
              value={inventoryData?.productCategory || []}
              onChange={(event, newValue) => {
                dispatch({ value: newValue, name: "productCategory" });
              }}
              filterSelectedOptions
              renderTags={(selected, getTagProps) =>
                (selected || []).map((option, index) => (
                  <Chip
                    key={index}
                    label={option.label}
                    {...getTagProps({ index })}
                  />
                ))
              }
              renderInput={(params) => (
                <TextField {...params} placeholder="Select Category(s)" />
              )}
            />
          </Grid>

          <Grid size={{ xs: 12, sm: 6 }}>
            <MaterialBox lineHeight={0} display="inline-block">
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Product Name
              </MaterialTypography>
            </MaterialBox>

            <Autocomplete
              multiple
              id="product-name-autocomplete"
              options={productNameOptions || []}
              getOptionLabel={(option) => option.label || ""}
              isOptionEqualToValue={(option, value) =>
                option.value === value.value
              }
              value={inventoryData?.productName || []}
              onChange={(event, newValue) => {
                dispatch({ value: newValue, name: "productName" });
              }}
              filterSelectedOptions
              renderOption={(props, option) => (
                <li {...props} key={option.id}>
                  {" "}
                  {option.label}
                </li>
              )}
              renderTags={(selected, getTagProps) =>
                selected?.map((option, index) => (
                  <Chip
                    key={option.id}
                    label={option.label}
                    {...getTagProps({ index })}
                  />
                ))
              }
              renderInput={(params) => (
                <TextField {...params} placeholder="Select Product Name(s)" />
              )}
            />
          </Grid>

          <Grid size={{ xs: 12, sm: 6 }}>
            <MaterialBox lineHeight={0} display="inline-block">
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Brand Name
              </MaterialTypography>
            </MaterialBox>
            <Autocomplete
              multiple
              id="brand-name-autocomplete"
              options={brandOptions || []}
              getOptionLabel={(option) => option.label || ""}
              value={inventoryData?.brand || []}
              onChange={(event, newValue) => {
                dispatch({ value: newValue, name: "brand" });
              }}
              filterSelectedOptions
              renderTags={(selected, getTagProps) =>
                (selected || []).map((option, index) => (
                  <Chip
                    key={option?.id}
                    label={option.label}
                    {...getTagProps({ index })}
                  />
                ))
              }
              renderInput={(params) => (
                <TextField {...params} placeholder="Select Brand(s)" />
              )}
            />
          </Grid>
        </ReusableFilter>
        {/* {!isTabel && <ReportDefaultUi setOpen={setDialogOpen} />} */}

        {!isLoading && isTabel && (
          <>
            {/* Conditional rendering based on selected tab */}
            {value === 0 ? (
              // Table list view (uses MaterialDataGrid's built-in pagination)
              <Box>
                <MaterialDataGrid
                  rows={RealtimeInventoryListTable?.rows}
                  columns={RealtimeInventoryListTable?.columns}
                  isSelectable={false}
                  localeText={{
                    noRowsLabel: (
                      <Stack
                        direction="column"
                        alignItems="center"
                        justifyContent="center"
                        spacing={1}
                      >
                        <MaterialTypography
                          variant="body2"
                          fontWeight="medium"
                          color="text"
                        >
                          No results match your filters
                        </MaterialTypography>

                        <MaterialTypography variant="caption" color="text">
                          Try adjusting or clearing the filters to see more
                          Realtime Inventory Management data.
                        </MaterialTypography>
                      </Stack>
                    ),
                  }}
                  pagination // Enable built-in pagination for MaterialDataGrid
                  paginationMode="server"
                  paginationModel={tablePaginationModel}
                  onPaginationModelChange={handleTablePaginationChange}
                  // pageSizeOptions={[10, 25, 50]}
                  // You can control initial page size and current page if needed, but DataGrid handles it
                  initialState={{
                    pagination: {
                      paginationModel: { pageSize: 10 },
                    },
                  }}
                  rowCount={totalCount}
                />
              </Box>
            ) : (
              // Graph list view (uses custom pagination controls)
              <ReportGraphPanel
                eyebrow="REAL-TIME INVENTORY"
                title="Inventory position"
                description="Original stock compared with current stock"
                page={currentPage}
                pageCount={totalPages}
                pageSize={tablePaginationModel.pageSize}
                totalCount={totalCount}
                isLoading={isLoading}
                onPageChange={handleGraphPageChange}
              >
                <ResponsiveContainer width="100%" height="100%">
                  <BarChart
                    data={currentData}
                    margin={{ top: 24, right: 22, left: 4, bottom: 72 }}
                    barSize={16}
                  >
                    <CartesianGrid stroke="#e4ebe5" strokeDasharray="3 5" />
                    <XAxis
                      dataKey="productName"
                      tick={{ fontSize: 9, fill: "#637168" }}
                      tickMargin={12}
                      tickFormatter={(name) =>
                        name?.length > 18 ? `${name.slice(0, 18)}...` : name
                      }
                      angle={-25}
                      textAnchor="end"
                      height={84}
                      interval={0}
                    />
                    <YAxis
                      tick={{ fontSize: 10, fill: "#637168" }}
                      tickMargin={8}
                    />
                    <Tooltip
                      contentStyle={{
                        fontSize: "11px",
                        borderRadius: "6px",
                        border: "1px solid #dfe8e1",
                        boxShadow: "0 5px 18px rgba(31, 55, 39, 0.12)",
                      }}
                      wrapperStyle={{
                        outline: "none",
                      }}
                    />
                    <Legend
                      verticalAlign="top"
                      align="right"
                      height={24}
                      wrapperStyle={{ fontSize: "11px", paddingBottom: "6px" }}
                    />
                    <Bar
                      dataKey="originalStock"
                      fill="#287b45"
                      name="Original Stock"
                    />
                    <Bar
                      dataKey="currentStock"
                      fill="#e4a64a"
                      name="Current Stock"
                    />
                  </BarChart>
                </ResponsiveContainer>
              </ReportGraphPanel>
            )}
          </>
        )}

        {isLoading && <PageLoading />}
      </Card>
    </DashboardLayout>
  );
}

export default RealtimeInventory;
